import React from "react";

const Footer = () => {
  return (
    <>
      {/* Footer principal */}
      <div
        className="container-fluid bg-dark text-light py-5 wow fadeInUp"
        data-wow-delay="0.3s"
        style={{ marginTop: "50px" }}
      >
        <div className="container pt-5">
          <div className="row g-5 pt-4">
            {/* Accesos rápidos */}
            <div className="col-lg-3 col-md-6">
              <h3 className="text-white mb-4">Accesos Rápidos</h3>
              <div className="d-flex flex-column justify-content-start">
                <a className="text-light mb-2" href="#">
                  <i className="bi bi-arrow-right text-primary me-2"></i>Inicio
                </a>
                <a className="text-light mb-2" href="/about">
                  <i className="bi bi-arrow-right text-primary me-2"></i>Sobre Lash
                </a>
                <a className="text-light mb-2" href="/services">
                  <i className="bi bi-arrow-right text-primary me-2"></i>Nuestros Servicios
                </a>
                <a className="text-light" href="/contact">
                  <i className="bi bi-arrow-right text-primary me-2"></i>Contáctanos
                </a>
              </div>
            </div>

            {/* Información de contacto */}
            <div className="col-lg-3 col-md-6">
              <h3 className="text-white mb-4">Estamos para atenderte</h3>
              <p className="mb-2">
                <i className="bi bi-geo-alt text-primary me-2"></i>
                Galería Moreno (Moreno esquina Salas y Valdez) Planta alta, Local 14, Yerba Buena
              </p>
              <p className="mb-2">
                <i className="bi bi-envelope-open text-primary me-2"></i>
                odontologialash@gmail.com
              </p>
              <p className="mb-0">
                <i className="bi bi-telephone text-primary me-2"></i>
                +54 381 561-5279
              </p>
            </div>

            {/* Redes sociales */}
            <div className="col-lg-3 col-md-6">
              <h3 className="text-white mb-4">Seguinos en nuestras redes</h3>
              <div className="d-flex">
                <a
                  className="btn btn-lg btn-primary btn-lg-square rounded me-2"
                  href="https://www.facebook.com/profile.php?id=100063991750220"
                >
                  <i className="fab fa-facebook-f fw-normal"></i>
                </a>
                <a
                  className="btn btn-lg btn-primary btn-lg-square rounded"
                  href="https://www.instagram.com/lash.odontologia/"
                >
                  <i className="fab fa-instagram fw-normal"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer inferior */}
      <div
        className="container-fluid text-light py-4"
        style={{ background: "#051225" }}
      >
        <div className="container">
          <div className="row g-0">
            <div className="col-md-6 text-center text-md-start">
              <p className="mb-md-0">
                &copy; <a className="text-white border-bottom" href="#">Lash</a>. Todos los derechos reservados.
              </p>
            </div>
            <div className="col-md-6 text-center text-md-end">
              <p className="mb-0">
                Diseñado por{" "}
                <a
                  className="text-white border-bottom"
                  href="#"
                >
                  ALTernate
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;